import script from "./sf-markdown-toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-markdown-toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./sf-markdown-toolbar.vue?vue&type=style&index=0&id=9038e6a9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9038e6a9"]])

export default __exports__